/**
 * Utilitários para filtro de dados por empresa
 */

/**
 * Verifica se um item pertence à empresa da sessão atual
 * @param item - Item com empresaId
 * @param session - Sessão do usuário
 * @returns boolean
 */
export const belongsToUserCompany = (item: any, session: any): boolean => {
  if (!item || !session?.empresa?.id) {
    return false;
  }

  const itemEmpresaId = String(item.empresaId || '');
  const sessionEmpresaId = String(session.empresa.id || '');
  
  return itemEmpresaId === sessionEmpresaId;
};

/**
 * Filtra uma lista de itens pela empresa da sessão
 * @param items - Lista de itens
 * @param session - Sessão do usuário
 * @param itemType - Tipo do item (para logs)
 * @returns Lista filtrada
 */
export const filterByUserCompany = (items: any[], session: any, itemType: string = 'itens'): any[] => {
  if (!items || !Array.isArray(items)) {
    console.warn(`⚠️ ${itemType}: Lista inválida recebida`);
    return [];
  }

  if (!session?.empresa?.id) {
    console.error(`❌ ${itemType}: Sessão ou empresa não encontrada`, {
      hasSession: !!session,
      hasEmpresa: !!session?.empresa,
      empresaId: session?.empresa?.id,
      usuarioEmpresaId: session?.usuario?.empresaId
    });
    return [];
  }

  const filtered = items.filter(item => belongsToUserCompany(item, session));
  
  return filtered;
};

/**
 * Verifica se o usuário tem permissão de administrador
 * @param session - Sessão do usuário
 * @returns boolean
 */
export const isAdministrator = (session: any): boolean => {
  return session?.usuario?.role === 'administrator' || session?.usuario?.role === 'admin';
};

/**
 * Obtém o ID da empresa da sessão
 * @param session - Sessão do usuário
 * @returns string | null
 */
export const getUserCompanyId = (session: any): string | null => {
  return session?.empresa?.id || null;
};
